const Footer = (data) => {
  if(!data) return {}

  const normalizedData = {
    ...data
  }

  return normalizedData
}

export default Footer
